<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1381.23 745.04">
    <g id="Graphics">
      <polygon
        class="cls-1"
        points="740.92 677.31 1021.02 677.31 1090.19 248.91 428.36 248.91 359.19 677.31 654.07 677.31 740.92 677.31"
      />
      <path
        class="cls-2"
        d="M648.17,682.93h-289a5.61,5.61,0,0,1-5.55-6.51L422.81,248a5.62,5.62,0,0,1,5.55-4.72h661.83a5.6,5.6,0,0,1,5.54,6.51l-69.16,428.41a5.62,5.62,0,0,1-5.55,4.72H648.17Zm92.75-11.24h275.31l67.36-417.16H433.14L365.79,671.69H740.92Z"
      />
      <path
        class="cls-2"
        d="M690,510.65a5.6,5.6,0,0,1-3.93-1.6L424.42,252.92a5.62,5.62,0,0,1,7.87-8l258.46,253,396.41-253.72a5.62,5.62,0,0,1,6.06,9.47L693.05,509.76A5.59,5.59,0,0,1,690,510.65Z"
      />
      <path
        class="cls-2"
        d="M1021,682.93a5.59,5.59,0,0,1-4.09-1.76L791.09,441.58a5.62,5.62,0,1,1,8.18-7.71l225.84,239.59a5.61,5.61,0,0,1-.24,7.94A5.56,5.56,0,0,1,1021,682.93Z"
      />
      <path
        class="cls-2"
        d="M359.18,682.93a5.61,5.61,0,0,1-4.25-9.28c.57-.66,57.51-66.81,114.84-132.15,117.54-134,121.66-134.13,125.65-134.3a5.87,5.87,0,0,1,4.38,1.66,5.61,5.61,0,0,1,.08,7.94,5.55,5.55,0,0,1-2.68,1.53C582.06,429.38,449.86,580.59,363.45,681A5.64,5.64,0,0,1,359.18,682.93ZM592,417Zm0,0Zm0,0h0Zm0,0Zm0,0h0Zm0,0h0Zm0,0Zm0,0Zm0,0h0Z"
      />
      <polygon class="cls-2" points="1078.34 256.49 818.5 462.47 798.87 441.64 1078.34 256.49" />
      <path
        class="cls-2"
        d="M818.51,468.09a5.65,5.65,0,0,1-4.1-1.76l-19.63-20.84a5.61,5.61,0,0,1,1-8.54L1075.24,251.8a5.62,5.62,0,0,1,6.59,9.09L822,466.87A5.55,5.55,0,0,1,818.51,468.09Zm-11-25.45,11.52,12.22L971.51,334Z"
      />
      <polygon class="cls-2" points="451.27 271.34 570.52 437.72 593.7 413.97 451.27 271.34" />
      <path
        class="cls-2"
        d="M570.52,443.34h-.42A5.65,5.65,0,0,1,566,441L446.71,274.61a5.62,5.62,0,0,1,8.54-7.24L597.67,410a5.62,5.62,0,0,1,.05,7.9l-23.18,23.75A5.6,5.6,0,0,1,570.52,443.34ZM496,324.05l75.21,105,14.62-15Z"
      />
      <path
        class="cls-3"
        d="M303.93,66.07c106.39,1.81,193.5,88.22,196.13,194.6a199.63,199.63,0,0,1-9.13,65.11l67,106.39a3.93,3.93,0,0,1-3.93,6L429,418.53a198.89,198.89,0,0,1-130.33,46.86c-109.55-1-198.6-91.49-197.87-201C101.52,153.55,192.51,64.18,303.93,66.07Z"
      />
      <path
        class="cls-2"
        d="M298.52,469.34A203.74,203.74,0,0,0,428,422.83l131.31,20.6a4.4,4.4,0,0,0,4.4-6.69L493.36,325a203.45,203.45,0,0,0,8.78-59.29c0-112.27-91.34-203.62-203.62-203.62S94.91,153.45,94.91,265.72,186.25,469.34,298.52,469.34Zm128.23-55.55a4.4,4.4,0,0,0-2.83,1,195,195,0,0,1-125.4,45.73c-107.43,0-194.83-87.4-194.83-194.83S191.09,70.89,298.52,70.89s194.83,87.4,194.83,194.83a194.93,194.93,0,0,1-9,58.6,4.37,4.37,0,0,0,.47,3.66l66.3,105.27L427.43,413.84A3.89,3.89,0,0,0,426.75,413.79Z"
      />
      <path
        class="cls-1"
        d="M402.32,212.17,386.6,196.45a9.07,9.07,0,0,0-12.82,0L274.42,295.8l-46.58-46.58a9.07,9.07,0,0,0-12.82,0L199.3,265a9,9,0,0,0,0,12.82L268,346.49a9.08,9.08,0,0,0,12.83,0L303,324.35h0L402.32,225A9.08,9.08,0,0,0,402.32,212.17Z"
      />
      <path
        class="cls-2"
        d="M1121.87,227.68a5.62,5.62,0,0,0,4.56-2.33l106-146.47a5.62,5.62,0,1,0-9.1-6.59l-106,146.47a5.63,5.63,0,0,0,4.55,8.92Z"
      />
      <path
        class="cls-2"
        d="M1153.29,250.87a5.71,5.71,0,0,0,2.46-.57L1230.33,214a5.62,5.62,0,0,0-4.92-10.1l-74.58,36.27a5.62,5.62,0,0,0,2.46,10.68Z"
      />
      <path
        class="cls-2"
        d="M1084,214.59a5.62,5.62,0,0,0,5.46-4.32L1110,123.56A5.62,5.62,0,1,0,1099,121l-20.55,86.7a5.64,5.64,0,0,0,4.18,6.77A5.76,5.76,0,0,0,1084,214.59Z"
      />
      <circle class="cls-2" cx="1272.11" cy="194.75" r="14.22" />
    </g>
  </svg>
</template>

<style scoped>
.cls-1 {
  fill: #fff;
}
.cls-2 {
  fill: #0a0a0a;
}
.cls-3 {
  fill: #5dbd6b;
}
</style>
